import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { Button } from "../../../components/ui/button";
import React, { useContext, useState } from "react";
import PinDashboardDialog from "../../../components/Pin/PinDashboard/PinDashboardDialog";
import AlertOverlay from "../../../pages/Dashboard/AlertOverlay";
import {
  deleteSectionWidgetAPI,
  fetchDashboardAPI,
  updateSectionWidgetLabelAPI,
} from "../../../api/dashboardApi";
import { DashboardContext } from "../../../pages/Dashboard";

const SectionWidgetHeader = ({
  widgetLabel,
  widgetId,
  dashboardId,
  sectionId,
  activeTab,
}) => {
  const [value, setValue] = useState(widgetLabel);
  const [isLoading, setIsLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isAlertOverlayOpen, setIsAlertOverlayOpen] = useState(false);
  const setDashboard = useContext(DashboardContext);
  const handleSubmit = async () => {
    await updateSectionWidgetLabelAPI({
      label: value,
      sectionId,
      dashboardId,
      widgetId,
      setIsLoading,
    });
    const data = await fetchDashboardAPI({
      dashboardId,
      setIsLoading: () => {},
    });
    setDashboard(data);
    setIsDialogOpen(false);
  };

  const handleDelete = async () => {
    await deleteSectionWidgetAPI({
      sectionId,
      widgetId,
      dashboardId,
      setIsLoading,
    });
    const data = await fetchDashboardAPI({
      dashboardId,
      setIsLoading: () => {},
    });
    setDashboard(data);
    setIsAlertOverlayOpen(false);
  };
  return (
    <div className="flex justify-between items-center  w-full border-b border-zinc-800 pb-1">
      <h2 className="capitalize text-zinc-400 truncate">{widgetLabel}</h2>
      <div className="flex gap-2 ">
        <div className="flex gap-1">
          <PinDashboardDialog
            value={value}
            title="Edit Label"
            description="Enter a label name for your widget"
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            onChange={(e) => setValue(e.target.value)}
            actionButtonName="Update Label"
          >
            <Button
              size="icon"
              className="hover:bg-zinc-700 bg-transparent rounded-full h-7 w-7 shadow-none"
            >
              <Pencil1Icon className="text-zinc-400" />
            </Button>
          </PinDashboardDialog>

          <AlertOverlay
            isAlertOverlayOpen={isAlertOverlayOpen}
            setIsAlertOverlayOpen={setIsAlertOverlayOpen}
            isLoading={isLoading}
            handleContinue={handleDelete}
            title={`Are you sure you want to delete?`}
            description="This action will permanently delete the selected widget"
          >
            <Button
              size="icon"
              className="hover:bg-zinc-700  bg-transparent rounded-full h-7 w-7 shadow-none"
            >
              <TrashIcon className="text-zinc-400" />
            </Button>
          </AlertOverlay>
        </div>
      </div>
    </div>
  );
};

export default SectionWidgetHeader;
